import { languageConstants } from 'constants/languageConstants';

export const buildFullName = (firstName: string, lastName: string): string => {
  return `${firstName} ${lastName}`;
};

export const isEmptyString = (value?: string) =>
  [undefined, null, ''].includes(value);

export const getAvatarName = (name: string) => {
  const avatarName = '';
  return name.split(' ').map((word) => {
    if (word[0] !== undefined) {
      return avatarName.concat(word[0]);
    }
    return '';
  });
};

export const buildInitials = (firstName: string, lastName: string): string => {
  return `${firstName.trim().charAt(0)} ${lastName.trim().charAt(0)}`;
};

export const getText = (
  key: keyof typeof languageConstants,
  language: 'ENGLISH' | 'SPANISH' = 'ENGLISH'
) => {
  if (language === null || language === undefined) {
    language = 'ENGLISH';
  }
  const text = languageConstants?.[key]?.[language];
  if (!text) {
    console.debug(`Text not found for key: ${key}, language: ${language}`);
  }
  return text;
};
